import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppRouter, ROUTER } from '../router/app-router.interface';

import { SystemStatus } from './system-status.domain';
import { SystemStatusService } from './system-status.service';

/**
 * Check system status
 */
@Injectable({
  providedIn: 'root'
})
export class SystemStatusChangeService implements OnDestroy {
  private systemStatusServiceSubscription: Subscription;

  constructor(private systemStatusService: SystemStatusService,
              @Inject(ROUTER) private appRouter: AppRouter) {
  }

  ngOnDestroy(): void {
    if (this.systemStatusServiceSubscription !== undefined) {
      this.systemStatusServiceSubscription.unsubscribe();
    }
  }

  init(): void {
    this.systemStatusService.onSystemStatusChange.subscribe((status: SystemStatus): void => {
      if (status === SystemStatus.MAINTENANCE || status === SystemStatus.DOWN) {
        this.appRouter.navigate('page.errors.maintenance');
      }
    });
  }
}
